@if (exchangeRate$ | async) {
    <div mat-dialog-content class="opportunity-dialog-content">
        <div [formGroup]="formGroup">
            <div class="form-row">
                <mat-form-field appearance="outline" style="flex-grow: 1">
                    <mat-label>Opportunity name</mat-label>
                    <textarea matInput required
                              formControlName="opportunityName"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="1"
                    ></textarea>
                </mat-form-field>
                <mat-checkbox appearance="outline" [formControl]="crateLinkedBudget">
                    <mat-label>Create linked budget</mat-label>
                </mat-checkbox>
            </div>
            <div class="form-row">
                <app-user-picker [myControl]="salesManagerControl"
                                 [displayWithEmail]=true
                                 [required]=true
                                 placeholder="Sales manager"
                                 appearance="outline"
                ></app-user-picker>
                <mat-form-field appearance="outline" style="min-width: 250px">
                    <mat-label>Opportunity stage</mat-label>
                    <mat-select formControlName="opportunityStage" required>
                        @for (stage of OpportunityStages | keyvalue; track stage) {
                            <mat-option [value]="stage.value">
                                {{ stage.value }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div style="width: 100%;">
                <app-company-search
                        [required]=true
                        [formControl_]="companySearchControl"
                        (companySelection)="setCompany($event)"
                ></app-company-search>
            </div>
            <div class="form-row">
                <mat-form-field appearance="outline" style="flex-grow: 1">
                    <mat-label>Sector</mat-label>
                    <mat-select formControlName="sector" required>
                        @for (sector of OpportunitySectors | keyvalue; track sector) {
                            <mat-option
                                    [value]="sector.value">
                                {{ sector.value }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Customer type</mat-label>
                    <mat-select formControlName="customerType" required>
                        @for (type of OpportunityCustomerTypes | keyvalue; track type) {
                            <mat-option
                                    [value]="type.value">
                                {{ type.value }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <app-country-selector [required]=true
                                      formControlName="country"
                                      appearance="outline"
                ></app-country-selector>
            </div>
            <div class="form-row">
                <mat-form-field appearance="outline">
                    <mat-label>Currency</mat-label>
                    <mat-select formControlName="currency">
                        <mat-option value='EUR'>EUR</mat-option>
                        <mat-option value='USD'>USD</mat-option>
                    </mat-select>
                </mat-form-field>
                @if (formGroup.get('currency').value === 'EUR') {
                    <mat-form-field appearance="outline">
                        <mat-label>Forecast amount ITA</mat-label>
                        <input matInput formControlName="forecastAmountITA" type="number"/>
                    </mat-form-field>
                }
                @if (formGroup.get('currency').value === 'USD') {
                    <mat-form-field appearance="outline">
                        <mat-label>Forecast amount USA</mat-label>
                        <input matInput formControlName="forecastAmountUSA" type="number"/>
                    </mat-form-field>
                }
            </div>
            <div class="form-row">
                <mat-form-field appearance="outline" style="flex-grow: 1">
                    <mat-label>Potential closure year</mat-label>
                    <input matInput type="number" formControlName="potentialClosureYear" required/>
                    @if (formGroup.get('potentialClosureYear').hasError('required')) {
                        <mat-error>
                            Required field
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="outline" style="min-width: 250px">
                    <mat-label>Potential closure - Semester</mat-label>
                    <mat-select formControlName="potentialClosureQuarter" required>
                        <mat-option [value]="'Semestre 1'">1° Semestre</mat-option>
                        <mat-option [value]="'Semestre 2'">2° Semestre</mat-option>
                    </mat-select>
                    @if (formGroup.get('potentialClosureQuarter').hasError('required')) {
                        <mat-error>
                            Required field
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Revision number</mat-label>
                    <mat-select formControlName="revisionNumber" required>
                        @for (i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track i) {
                            <mat-option [value]="i">{{ i }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-row" style="margin-top: 10px">
                @if (formGroup.get('opportunityStage').value === OpportunityStages[2]) {
                    <mat-form-field appearance="outline"
                                    style="max-width: 250px">
                        <mat-label>Proposal Sent On</mat-label>
                        <input matInput [matDatepicker]="proposalSentOn" formControlName="proposalSentOn"
                               (click)="proposalSentOn.open()">
                        <mat-datepicker-toggle [for]="proposalSentOn" matSuffix></mat-datepicker-toggle>
                        <mat-datepicker #proposalSentOn></mat-datepicker>
                        <mat-hint style="white-space: nowrap;">When the proposal has been sent to the client</mat-hint>
                    </mat-form-field>
                }
                @if (formGroup.get('opportunityStage').value === OpportunityStages[1]) {
                    <mat-form-field appearance="outline"
                                    style="max-width: 250px">
                        <mat-label>Proposal requested On</mat-label>
                        <input matInput [matDatepicker]="proposalRequested" formControlName="proposalRequested"
                               (click)="proposalRequested.open()">
                        <mat-datepicker-toggle [for]="proposalRequested" matSuffix></mat-datepicker-toggle>
                        <mat-datepicker #proposalRequested></mat-datepicker>
                        <mat-hint style="white-space: nowrap;">When the client has asked for a proposal</mat-hint>
                    </mat-form-field>
                }
                <mat-form-field appearance="outline" style="max-width: 250px">
                    <mat-label>Next follow-up</mat-label>
                    <input matInput required [matDatepicker]="nextFollowUp" formControlName="nextFollowUpDate"
                           (click)="nextFollowUp.open()">
                    <mat-datepicker-toggle [for]="nextFollowUp" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #nextFollowUp></mat-datepicker>
                    <mat-hint style="font-size: 10px; white-space: nowrap;">A reminder email will be scheduled for this
                        date
                    </mat-hint>
                </mat-form-field>
            </div>
            <mat-divider></mat-divider>
            <div style="flex-grow: 1; margin-top: 10px">
                <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Notes</mat-label>
                    <textarea matInput
                              formControlName="nextSteps"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="1"
                    ></textarea>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div mat-dialog-actions style="display: flex; justify-content: space-between">
        <button mat-flat-button mat-dialog-close>Cancel</button>
        <button mat-flat-button color="primary" (click)="save()"
                [disabled]="formGroup.invalid || companySearchControl.invalid"
        >Save
        </button>
    </div>
} @else {
    <div style="width: 300px">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
}
